module.exports = __webpack_public_path__ + "img/emoji_51.bbac01b6.png";